import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_sj8w9rby65: FaireCollectionEntity = {
  token: "pbc_sj8w9rby65",
  type: "collection",
  name: "seaside collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c8ba7ca9cfa79df521e2b4528c0f88c7bf0d8100631d39506c440293e6a8553d.jpeg",
  itemCount: 21,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.718Z",
    importedBy: "entity-db-import-collections",
  },
};
